import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { authdApiRequest } from '../utils/api';
import LoadingScreen from '../components/LoadingScreen';

function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [snapshots, setSnapshots] = useState([]);
  const [completedSnapshots, setCompletedSnapshots] = useState(new Set());
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSnapshots = async () => {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys`);
        const data = await response.json();
        setSnapshots(data);
      } catch (error) {
        console.error('Error fetching snapshots:', error);
      }
    };

    const fetchSnapshotResponses = async () => {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/done`);
        const data = await response.json();
        const completed = new Set(data);
        setCompletedSnapshots(completed);
      } catch (error) {
        console.error('Error fetching snapshots responses:', error);
      }
    };

    fetchSnapshots();
    fetchSnapshotResponses();
    setLoading(false);
    
  }, []);

  const isSnapshotAvailable = (snapshot) => {
    const now = new Date();
    const startDate = new Date(snapshot.startDate);
    const endDate = new Date(snapshot.endDate);
    return !snapshot.closed && !snapshot.processed && now >= startDate && now <= endDate;
  };

  useEffect(() => {
    document.title = 'Home - DevWing';
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const hasSavedState = (snapshotId) => {
    return localStorage.getItem(`snapshotState-${snapshotId}`) !== null;
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Layout>
      <div className="space-y-4">
        {snapshots.map((snapshot) => (
          <div key={snapshot.id} className="bg-neutral-900 p-4 border border-neutral-700 rounded-md">
            <h2 className="text-xl font-semibold">{formatDate(snapshot.endDate)} Snapshot</h2>
            {snapshot ? (
              <p className="text-sm text-neutral-400">
                {snapshot.title}
              </p>
            ) : ""}
            {completedSnapshots.has(snapshot.id) ? (
              <div className="text-green-500 mt-2">Completed</div>
            ) : isSnapshotAvailable(snapshot) ? (
              <div className="flex items-center space-x-2 mt-2">
                <button
                  onClick={() => navigate(`/complete/${snapshot.id}`)}
                  className="bg-sky-500 px-2 py-1 rounded-md text-white transition hover:bg-sky-700 border-none cursor-pointer"
                >
                  Complete Snapshot
                </button>
                {hasSavedState(snapshot.id) && (
                  <button
                    onClick={() => navigate(`/complete/${snapshot.id}`, { state: { loadSavedState: true } })}
                    className="bg-green-500 px-2 py-1 rounded-md text-white transition hover:bg-green-700 border-none cursor-pointer"
                  >
                    Load Saved
                  </button>
                )}
              </div>
            ) : (
              <p className="text-neutral-500 mt-2">Snapshot not available for completion</p>
            )}
            {snapshot.released && (
              <button
                onClick={() => navigate(`/snapshots/${snapshot.id}/results`)}
                className="bg-green-500 px-2 py-1 mt-2 text-white text-sm rounded-md"
              >
                Show Results
              </button>
            )}
          </div>
        ))}
      </div>
    </Layout>
  );
}

export default Dashboard;
